import { CommonModule } from '@angular/common';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Cotizacion } from '../../interface/Cotizacion';
import { PraxisService } from '../../service/praxis.service';
import { DialogAlertaComponent } from '../../../../dialog-alerta/dialog-alerta.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-cotizacion',
  templateUrl: './cotizacion.component.html',
  styleUrl: './cotizacion.component.css',
  standalone: false,
})
export class CotizacionComponent implements OnInit {

  constructor(
    private praxisService: PraxisService,
    public dialog: MatDialog
  ){}

  public cotizacion: Cotizacion | undefined = undefined;
  nombre: string | null = '';
  //uasfechaActual: string = '';

  ngOnInit(): void {
    //console.log('Cotizacion')
    this.nombre = localStorage.getItem('nombre');
    this.praxisService.getCotizarSolicitar(
                                          localStorage.getItem('token'),
                                          localStorage.getItem('uuid'),
                                          localStorage.getItem('ramo'),
                                          localStorage.getItem('solicitar'),
                                          localStorage.getItem('conducto_pago'),
                                          localStorage.getItem('iibb'),
                                          localStorage.getItem('iva'),
                                          localStorage.getItem('tipo_persona'),
                                          localStorage.getItem('tipo_matricula'),
                                          localStorage.getItem('matricula'),
                                          localStorage.getItem('codigo_especialidad'),
                                          localStorage.getItem('titulo'),
                                          localStorage.getItem('suma_asegurada'),
                                          localStorage.getItem('apellido'),
                                          localStorage.getItem('nombre'),
                                          localStorage.getItem('cp'),
                                          '',
                                          '',
                                          localStorage.getItem('tipo_documento'),
                                          '',
                                          localStorage.getItem('celular'),
                                          localStorage.getItem('email'),
                                          '',
                                          '',
                                          this.obtenerFechaActual(),
                                          localStorage.getItem('jefe'),
                                          localStorage.getItem('director'),

                                          )
                      .subscribe(
                        (datos) => {
                          this.cotizacion = datos;
                          if(this.cotizacion.resultado=='Error'){
                            const dialogRef = this.dialog.open(DialogAlertaComponent);
                            //alert(this.cotizacion.mensajes);
                          }
                        }
                      )
  }

  obtenerFechaActual() {
    let fecha = new Date();
    let year = fecha.getFullYear();
    let month = (fecha.getMonth() + 1).toString().padStart(2, '0'); // Agrega un cero al principio si el mes es menor a 10
    let day = fecha.getDate().toString().padStart(2, '0'); // Agrega un cero al principio si el día es menor a 10

    return `${year}${month}${day}`;
    //return this.fechaActual;
    //console.log(this.fechaActual); // Resultado: Por ejemplo, '20220513' para el 13 de mayo de 2022
  }

}





